module.exports = __webpack_public_path__ + "img/family.dd96f33e.svg";